import { ShareProvider } from './share-provider.enum'
import { ShareArgs } from './share-args'
import { ShareLinks } from './share-links.functions'

export class ShareFactory {

  public static createSharerUrl(type: ShareProvider, args: ShareArgs): string {
    switch (type) {
      case ShareProvider.FACEBOOK:
        return ShareLinks.facebookShare(args)
      case ShareProvider.TWITTER:
        return ShareLinks.twitterShare(args)
      case ShareProvider.GOOGLEPLUS:
        return ShareLinks.googlePlusShare(args)
      default:
        return ''
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/social-share/shared/share-factory.ts